/* =====================================================================
   UCHI — Reading pages behaviour (About, Method)
   - Sticky chapter/step index that sits right under the theme header
   - Active chapter + reading progress
   - Method: sticky bar "Step N of 5" after the recipe card
   ===================================================================== */

const $$ = (root, sel) => [...root.querySelectorAll(sel)];

/* ---------- Keep sticky bars under the (sometimes hiding) header ---------- */
const headerGroup = document.getElementById('header-group') || document.querySelector('.header-section, header');
let topRaf = 0;
function syncTop() {
  topRaf = 0;
  let top = 0;
  if (headerGroup) {
    const r = headerGroup.getBoundingClientRect();
    top = Math.max(0, Math.round(r.bottom));
  }
  document.documentElement.style.setProperty('--u3-top', `${top}px`);
}
if (!window.__u3ReadTop) {
  window.__u3ReadTop = true;
  window.addEventListener('scroll', () => { if (!topRaf) topRaf = requestAnimationFrame(syncTop); }, { passive: true });
  window.addEventListener('resize', syncTop);
  syncTop();
}

/* ---------- Index + progress ---------- */
function initIndex(root) {
  const links = $$(root, '[data-read-link]');
  const chapters = $$(root, '[data-read-chapter]');
  const bar = root.querySelector('[data-read-progress]');
  const navList = root.querySelector('[data-read-nav] > div');
  if (!chapters.length) return;

  let current = '';
  const setActive = (id) => {
    if (id === current) return;
    current = id;
    links.forEach((a) => {
      const on = a.dataset.readLink === id;
      a.classList.toggle('is-on', on);
      if (on) {
        a.setAttribute('aria-current', 'true');
        if (navList && navList.scrollWidth > navList.clientWidth) {
          navList.scrollTo({ left: a.offsetLeft - 20, behavior: 'smooth' });
        }
      } else a.removeAttribute('aria-current');
    });
    root.dispatchEvent(new CustomEvent('read:chapter', { detail: { id } }));
  };

  let raf = 0;
  const update = () => {
    raf = 0;
    const line = window.innerHeight * 0.35;
    let active = chapters[0].dataset.readChapter;
    for (const c of chapters) {
      if (c.getBoundingClientRect().top <= line) active = c.dataset.readChapter;
    }
    setActive(active);
    if (bar) {
      const r = root.getBoundingClientRect();
      const total = r.height - window.innerHeight;
      const p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
      bar.style.width = `${(p * 100).toFixed(1)}%`;
    }
  };
  window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
  update();

  links.forEach((a) => a.addEventListener('click', (e) => {
    const target = document.getElementById(a.dataset.readLink);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    history.replaceState(history.state, '', `#${a.dataset.readLink}`);
  }));
}

/* ---------- Method sticky bar ---------- */
function initStepsSticky(root) {
  const bar = root.querySelector('[data-read-sticky]');
  if (!bar || !('IntersectionObserver' in window)) return;
  const stepEl = bar.querySelector('[data-read-step]');
  const recipe = document.querySelector('[data-read-recipe]');
  let past = !recipe;
  let hidden = false;
  const render = () => {
    const show = past && !hidden;
    bar.classList.toggle('is-visible', show);
    bar.toggleAttribute('inert', !show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
  };
  if (recipe) {
    new IntersectionObserver(([e]) => { past = !e.isIntersecting && e.boundingClientRect.top < 0; render(); }).observe(recipe);
  }
  const blockers = $$(document, '[data-u3-buybar-hide], footer, .shopify-section-group-footer-group');
  const over = new Set();
  if (blockers.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) over.add(e.target); else over.delete(e.target); });
      hidden = over.size > 0;
      render();
    });
    blockers.forEach((b) => io.observe(b));
  }
  root.addEventListener('read:chapter', (e) => {
    const el = document.getElementById(e.detail.id);
    if (el && stepEl) stepEl.textContent = el.dataset.step || '1';
  });
}

/* ---------- Video (iOS sometimes needs a nudge) ---------- */
function kickVideos(root) {
  $$(root, '.u3-ahero video').forEach((v) => { v.muted = true; const p = v.play && v.play(); if (p && p.catch) p.catch(() => {}); });
}

/* ---------- Boot ---------- */
function init(scope = document) {
  $$(scope, '[data-read]').forEach((root) => {
    if (root.dataset.readReady) return;
    root.dataset.readReady = '1';
    initIndex(root);
    if (root.dataset.read === 'steps') initStepsSticky(root);
  });
  kickVideos(scope);
}
init();
document.addEventListener('shopify:section:load', (e) => { init(e.target); syncTop(); });
